//import ArvoreMenu from '@/portal/dominio/navegacao/ArvoreMenu.js';
//import ItemMenu from '@/portal/dominio/navegacao/ItemMenu';

const LicitacoesDetalhes = () => import(/* webpackChunkName: "chunk-licitacoes" */ '../views/LicitacoesDetalhes')
const LicitacoesInicio = () => import(/* webpackChunkName: "chunk-licitacoes" */ '../views/LicitacoesInicio')

export const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: LicitacoesInicio,
    meta: {
      breadcrumb:[
        { nome: 'Compras' }
      ]
    }
  },
  {
    path: '/:codpcddsp',
    name: 'Detalhamento',
    component: LicitacoesDetalhes,
    meta: {
      breadcrumb:[
        { nome: 'Compras', link: '/licitacoes/' },
        { nome: 'Compra #${codpcddsp}', link: '/licitacoes/${codpcddsp}' },
      ]
    }
  }
]